import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-return-detail',
  standalone: false,
  
  templateUrl: './sales-return-detail.component.html',
  styles: ``
})
export class SalesReturnDetailComponent {

}
